import React from "react";
import { useTranslation } from "react-i18next";
import { Brain, ShieldCheck, UserCheck } from "lucide-react";
import { BrandLogo } from "@/components/common/BrandLogo";

export const AuthLayout = ({ title, subtitle, children, footer }) => {
  const { t } = useTranslation();
  const points = [
    { icon: Brain, text: t("auth.heroPoints.one") },
    { icon: UserCheck, text: t("auth.heroPoints.two") },
    { icon: ShieldCheck, text: t("auth.heroPoints.three") },
  ];
  return (
    <div className="grid min-h-screen bg-background lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]" data-testid="auth-layout">
      <aside className="og-noise relative hidden flex-col justify-between overflow-hidden border-r border-border bg-slate-50 p-10 lg:flex">
        <div className="pointer-events-none absolute -left-20 -top-20 h-72 w-72 rounded-full bg-sky-100/70 blur-3xl" aria-hidden="true" />
        <div className="relative">
          <BrandLogo size="lg" />
        </div>
        <div className="relative max-w-md">
          <h2 className="font-heading text-3xl font-semibold leading-tight tracking-tight text-foreground">{t("auth.heroTitle")}</h2>
          <p className="mt-4 text-base text-muted-foreground">{t("auth.heroSubtitle")}</p>
          <ul className="mt-8 space-y-4">
            {points.map(({ icon: Icon, text }) => (
              <li key={text} className="flex items-start gap-3 text-sm text-foreground">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-border bg-card"><Icon className="h-4 w-4 text-primary" aria-hidden="true" /></span>
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="relative text-xs text-muted-foreground">{t("app.name")} · {t("app.by")}</div>
      </aside>

      <main className="flex flex-col">
        <div className="flex items-center justify-between px-6 py-5 lg:hidden">
          <BrandLogo />
        </div>
        <div className="flex flex-1 items-center justify-center px-4 pb-10 sm:px-6">
          <div className="w-full max-w-[440px]">
            <div className="mb-6">
              <h1 className="font-heading text-2xl font-semibold tracking-tight md:text-[28px]" data-testid="auth-title">{title}</h1>
              {subtitle && <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>}
            </div>
            <div className="og-card p-6 sm:p-7">{children}</div>
            {footer && <div className="mt-5 text-center text-sm text-muted-foreground">{footer}</div>}
            <p className="mt-6 text-center text-xs text-muted-foreground">{t("auth.securityNote")}</p>
          </div>
        </div>
      </main>
    </div>
  );
};
